/* global axios */
import ApiClient from './ApiClient';

class JoopCopilotAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  context(conversationId) {
    return axios.get(`${this.url}/${conversationId}/joop_copilot`);
  }

  generate(conversationId, regenerate = false) {
    return axios.post(`${this.url}/${conversationId}/joop_copilot`, {
      regenerate,
    });
  }

  review(conversationId, payload) {
    return axios.patch(`${this.url}/${conversationId}/joop_copilot`, payload);
  }
}

export default new JoopCopilotAPI();
